"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'FgInput',
  inheritAttrs: false,
  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    labelClasses: {
      type: String,
      default: ''
    },
    inputClasses: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    addonRightIcon: {
      type: String,
      default: ''
    },
    addonLeftIcon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      focused: false
    };
  },
  computed: {
    listeners: function listeners() {
      return _objectSpread(_objectSpread({}, this.$listeners), {}, {
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      });
    },
    hasIcon: function hasIcon() {
      var _this$$slots = this.$slots,
        addonRight = _this$$slots.addonRight,
        addonLeft = _this$$slots.addonLeft;
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  },
  methods: {
    updateValue: function updateValue(evt) {
      var value = evt.target.value;
      this.$emit('input', value);
    },
    onFocus: function onFocus(value) {
      this.focused = true;
      this.$emit('focus', value);
    },
    onBlur: function onBlur(value) {
      this.focused = false;
      this.$emit('blur', value);
    }
  }
};